import React, { useState, useEffect } from "react";

// common function
import { tempHumStationLatLon } from "../scripts/station";
import { tempMarker } from "../scripts/tempMarker";
import { fetchingTime } from "../../../../config/fetching";

// function
import { getTempInformation } from "../../../service/apiWeatherInfoService";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/tempMap.scss";
// mapTitle sheet
import "../scss/mapTitleMap.scss";

// leaflet css
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import "leaflet-defaulticon-compatibility";

// Openstreetmap components
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  ZoomControl,
  useMapEvents,
} from "react-leaflet";

// L component
import * as Leaflet from "leaflet";

// Watermark
import Watermark from "../../../../resources/image/watermark.jpg";

//#region Map Watermark
const WatermarkControl = () => {
  const map = useMap();
  const watermark = map.getContainer().querySelector(".watermark");

  if (!watermark) {
    const watermark = new Leaflet.Control({ position: "bottomleft" });
    watermark.onAdd = function (map) {
      var div = Leaflet.DomUtil.create("div", "watermark");
      div.innerHTML = "<img src='" + Watermark + "' width='75' height='75'>";
      return div;
    };
    watermark.addTo(map);
    // React.useEffect(() => {

    // }, [map]);
  }

  return null;
};

//#endregion END

type Props = { enable: number; autoUpdate?: boolean };
type tempInfo_Props = { station: string; temp: string; time: string };

function TempMap({ enable, autoUpdate }: Props) {
  const [isMapOn, setIsMapOn] = useState<React.Key>(0);
  const [tempArray, setTempArray] = useState<Array<tempInfo_Props>>([]);
  const [time, setTime] = useState<string>("");

  const [zoomLevel, setZoomLevel] = useState<number>(11);

  const position: Leaflet.LatLngExpression = [22.35, 114.125];

  // zoom change
  const ZoomListener = () => {
    useMapEvents({
      zoomend: (event) => {
        const map = event.target;
        const zoom = map.getZoom();

        setZoomLevel(zoom);
      },
    });
    return null;
  };

  async function getFetchTempInfomation() {
    await getTempInformation()
      .then((response) => {
        return response.data.data;
      })
      .then((data) => {
        setTempArray(data);
        setTime(data[0].time);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      if (autoUpdate === true) {
        getFetchTempInfomation();
      }
    };

    getFetchTempInfomation(); // Initial fetch

    let intervalId = setInterval(() => {
      fetchData();
    }, fetchingTime);

    return () => {
      clearInterval(intervalId);
    };
  }, [autoUpdate]);

  useEffect(() => {
    setIsMapOn(enable);

    // Reset the zoom level
    setZoomLevel(11);
  }, [enable]);

  return (
    <div className="mapContainer">
      <MapContainer
        zoom={11}
        maxZoom={12}
        minZoom={11}
        zoomControl={false}
        center={position}
        scrollWheelZoom={false}
        key={isMapOn}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <ZoomControl position="topright" />

        <WatermarkControl />

        <ZoomListener />

        {tempArray.map((item) => {
          if (
            (item.station === "King's Park" ||
              item.station === "Wong Tai Sin" ||
              item.station === "Tsuen Wan Ho Koon" ||
              item.station === "HK Park") &&
            zoomLevel === 11
          ) {
            return null;
          } else {
            //tempMarker(item.temp)
            return (
              <Marker
                key={`temp-${item.station}`}
                position={tempHumStationLatLon(item.station)}
                icon={tempMarker(item.temp)}
              />
            );
          }
        })}
      </MapContainer>
      <div className="mapDescription">
        <div>各地氣溫(°C)</div>
        <div>
          {time.substr(4, 2)}月{time.substr(6, 2)}日 {time.substr(8, 2)}:
          {time.substr(10, 2)}更新
        </div>
      </div>
    </div>
  );
}

export default TempMap;
